import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { CountdownCalc } from "../components/CountdownCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.cd_tool_name()}
        toolPath="/countdown-timer"
      />
      <SciHeader title={m.cd_h1()} intro={m.cd_intro()} />
      <CountdownCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.cd_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.cd_ex1(), m.cd_ex2(), m.cd_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.cd_faq_q1(), a: m.cd_faq_a1() },
          { q: m.cd_faq_q2(), a: m.cd_faq_a2() },
          { q: m.cd_faq_q3(), a: m.cd_faq_a3() },
          { q: m.cd_faq_q4(), a: m.cd_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
